module.exports = __webpack_public_path__ + "img/bn(2).b34c7519.png";